import MinutesToText from '@/components/ezuro/common/MinutesToText.vue'
import useVuelidate from '@vuelidate/core';
import { required } from '@vuelidate/validators';

const defaultEl = {
  id: null,
  schedule_row_id: '',
  event_id: '',
  minutes: 0,
  notes: ''
};

export default {
  name: 'RecordEventsEdit',
  components: {
    MinutesToText
  },
  data () {
    return {
      editEl: defaultEl,
      isLoading: false
    }
  },
  validations: {
    editEl: {
      event_id: { required },
      minutes: { required },
      notes: {}
    }
  },
  props: {
    editPerm: {
      type: String,
      default: 'edit-records-events'
    },
    basePath: {
      type: String,
      default: 'ezuro/schedule/row/event'
    },
    isModal: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    eventOptions () {
      const path = 'ezuro/events/list?perPage=10000';
      const events = [];
      this.$emit('setLoading', true);
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const key in response.data) {
            events.push({ value: response.data[key].id, text: response.data[key].name });
          }
          this.$emit('setLoading', false);
        }
      });

      return events;
    },
    baseTransParam () {
      return 'work-schedule';
    },
    getTitle () {
      if (this.editEl.id) {
        return this.$t(`${this.baseTransParam}.edit-schedule-row-event`);
      }
      return this.$t(`${this.baseTransParam}.add-schedule-row-event`);
    },
    canEdit () {
      return !this.isLoading;
    }
  },
  methods: {
    show (elData) {
      if (elData) {
        this.editEl = this.BasicHelper.cloneObject(elData);
      } else {
        this.editEl = this.BasicHelper.cloneObject(defaultEl);
      }
      this.v$.$reset();
      if (this.isModal) {
        this.$refs['modal-window'].show();
      }
    },
    save () {
      this.v$.$touch();
      if (!this.v$.$invalid && !this.isLoading) {
        this.isLoading = true;
        const reqData = { };
        for (const key of Object.keys(defaultEl)) {
          reqData[key] = this.editEl[key];
        }
        this.ApiRequest.request(this.basePath + '/save' + (reqData.id ? '/' + reqData.id : ''), this.ApiRequest.REQUEST_POST, reqData, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.$emit('saved');
            this.close();
          }
          this.isLoading = false;
        });
      }
    },
    close () {
      if (this.isModal) {
        this.$refs['modal-window'].hide();
      }
    }
  },
  setup () {
    return { v$: useVuelidate() }
  }
}
